import { SkeletonLoading } from "@/main/components/shared/styles";
import * as S from "./styles";

function SkeletonRowDetailsMappingParts() {
	return (
		<S.ContainerRow>
			<S.ContainerLabel $labelContent={""}>
				<SkeletonLoading $height="30px" />
			</S.ContainerLabel>
			<S.ContainerLabel $labelContent={""}>
				<SkeletonLoading $height="30px" />
			</S.ContainerLabel>
			<S.ContainerLabel $labelContent={""}>
				<SkeletonLoading $height="30px" />
			</S.ContainerLabel>
			<S.ContainerLabel $labelContent={""}>
				<SkeletonLoading $height="30px" />
			</S.ContainerLabel>
			<S.ContainerLabel $labelContent={""}>
				<SkeletonLoading $height="30px" />
			</S.ContainerLabel>
			<S.ContainerLabel $labelContent={""}>
				<SkeletonLoading $height="20px" />
			</S.ContainerLabel>
		</S.ContainerRow>
	);
}

export default SkeletonRowDetailsMappingParts;
